<template>
    <BaseModal @close="$emit('close')" modal-type="timeout">
        <template #header>
            <h2
                class="paymentTimeoutModal__title"
                id="paymentTimeoutModal__title"
                v-text="$ml.get('timeoutTitle')"
            />
        </template>
        <div>
            <span class="paymentTimeoutModal__description" v-text="$ml.get('timeoutDescription')" />
        </div>
        <template #footer>
            <button class="base-modal__btn base-modal__btn--primary" @click="$emit('close')">
                {{ $ml.get('close') }}
            </button>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue';
export default {
  name: 'PaymentTimeoutModal',
  components: { BaseModal }
};
</script>

<style scoped lang="scss">
.paymentTimeoutModal {
	&__title {
		font-size: 20px;
		font-weight: 700;
		color: #2F363E;
	}
	&__description {
		font-size: 16px;
		color: #5C6A7B;
	}
}
</style>
